import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "Guardia · Iron Glove";
const DEFAULT_IMG = "https://images.unsplash.com/flagged/photo-1574005280900-3ff489fa1f70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

export default function Seo({ title, description, image, type = "website", url, alternates }) {
  const fullTitle = title ? `${title} — ${SITE}` : SITE;
  const desc = description || "Boxe · Kickboxing · Scienza dello striking. Guide tecniche, recensioni e un programma di allenamento interattivo.";
  const raw = image || DEFAULT_IMG;
  const img = raw.startsWith("/") ? `${window.location.origin}${raw}` : raw;
  const en = new URLSearchParams(window.location.search).get("lang") === "en";
  const path = window.location.pathname.replace(/\/+$/, "") || "/";
  const canonical = url || `${window.location.origin}${path}${en ? "?lang=en" : ""}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {canonical && <link rel="canonical" href={canonical} />}
      {(alternates || []).map((a) => (
        <link key={a.lang} rel="alternate" hrefLang={a.lang} href={a.url} />
      ))}
      {alternates && alternates.length > 0 && (
        <link rel="alternate" hrefLang="x-default" href={(alternates.find((x) => x.lang === "it") || alternates[0]).url} />
      )}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:site_name" content={SITE} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
